import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";
import { String } from "lodash";

export type respSendPDF={
  code:number
  message:string;
  salesOffices?:string[];
  customers?:string[];
  rateLimit?:number;
}
export async function sendAllPDFs(salesOrg: string): Promise<any> {
  
  const config: AxiosRequestConfig = {
    method: "POST",
    params:{
      clientId: "100",
      salesOrg
    },
    url: `${BASE_URL}/api/internalsupport/SendEmails/Requests/PDF`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function sendPDF(salesOrg: string, requestNum:number): Promise<any> {
  
  const config: AxiosRequestConfig = {
    method: "POST",
    params:{
      clientId: "100",
      salesOrg,
      requestNum
    },
    url: `${BASE_URL}/api/internalsupport/SendEmails/Requests/PDF/Resend`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function uploadBankCSV(salesOrg: string, salesOffice: string, bankData: File): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  if(salesOffice !== '*'){
    params.salesOffice = salesOffice
  }
  
  let data = new FormData();
  data.append('banks', bankData);

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/banks/stage`,
    data: data,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}



export async function approveBankCSV(salesOrg: string, salesOffice: string, keyId: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  if(salesOffice !== '*'){
    params.salesOffice = salesOffice
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/banks/apply`,
    data: {keyId:keyId},
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}


interface EmailDL {
  salesOffice: string;
  deliveringPlant: string;
  dlName:string;
  email:string;
}
export async function saveEmailDL(salesOrg: string, toDelete:EmailDL|undefined, toAdd:EmailDL|undefined): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/email/dl`,
    data: {
      delete:(toDelete) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          salesOffice:toDelete.salesOffice,
          deliveringPlant:toDelete.deliveringPlant,
          dlName:toDelete.dlName,
          email:toDelete.email
        }]) : ([]),
      add:(toAdd) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          salesOffice:toAdd.salesOffice,
          deliveringPlant:toAdd.deliveringPlant,
          dlName:toAdd.dlName,
          email:toAdd.email
        }]) : ([]),
      },
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

interface MaterialReplacement {
  salesOffice: string;
  dlName:string;
  email:string;
}
export async function saveMaterialReplacement(salesOrg: string, toDelete:MaterialReplacement|undefined, toAdd:MaterialReplacement|undefined): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/material/replace`,
    data: {
      delete:(toDelete) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          salesOffice:toDelete.salesOffice,
          dlName:toDelete.dlName,
          email:toDelete.email
        }]) : ([]),
      add:(toAdd) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          salesOffice:toAdd.salesOffice,
          dlName:toAdd.dlName,
          email:toAdd.email
        }]) : ([]),
      },
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}


interface syConfig{
  client_id?: number;
  sales_org?: string;    
  param_name: string;
  param_value: string | null;
}
export async function saveSyConfiguration(salesOrg: string, app:{vp?:boolean,vs?:boolean}, update:syConfig[]): Promise<any> {

  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      vs: (app.vs)?1:0,
      vp: (app.vp)?1:0,
    },
    data:{update},
    url: `${BASE_URL}/api/admin/configuration`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

interface syPlanModeConfig{
  client_id?: number;
  sales_org?: string;    
  delivering_plant: string;
  plan_mode : string;
  is_default : boolean;
  guid?: string;
}

export async function saveSyPlanConfiguration(salesOrg: string, update:syPlanModeConfig[]): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    data:{update},
    url: `${BASE_URL}/api/admin/planmodeconfig`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

interface sOffOpDays {
  client_id?: number;
  sales_org?: string;   
  delivering_plant?: string;
  sales_office?: string;
  mon:boolean;
  tue:boolean;
  wed:boolean;
  thu:boolean;
  fri:boolean;
  sat:boolean;
  sun:boolean;
}
export async function saveSalesOfficeOperation(salesOrg: string, deliveringPlant: string, salesOffice: string, update: sOffOpDays): Promise<any> {
  update = {
    ...update,
    client_id: 100,
    sales_org: salesOrg,
    delivering_plant: deliveringPlant,
    sales_office: salesOffice,
  }
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    data:{update:[update]},
    url: `${BASE_URL}/api/admin/salesoffice/operation`,
  };
  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


interface OptimizationParameters {
  salesOffice: string;
  deliveringPlant:string;
  paramName:string;
  paramValue:string;
}

export async function saveOptimizationParameters(salesOrg: string, toDelete:OptimizationParameters|undefined, toAdd:OptimizationParameters|undefined): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/optimization/parameters`,
    data: {
      delete:(toDelete) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          salesOffice:toDelete.salesOffice,
          deliveringPlant: toDelete.deliveringPlant,
          paramName:toDelete.paramName,
          paramValue:toDelete.paramValue
        }]) : ([]),
      update:(toAdd) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          salesOffice:toAdd.salesOffice,
          deliveringPlant: toAdd.deliveringPlant,
          paramName:toAdd.paramName,
          paramValue:toAdd.paramValue
        }]) : ([]),
      },
  };
  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}



export async function uploadNoteCSV(salesOrg: string, noteData: File): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  let data = new FormData();
  data.append('notes', noteData);

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/notes/stage`,
    data: data,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function uploadImageValidCSV(salesOrg: string, noteData: File): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  let data = new FormData();
  data.append('ValidImages', noteData);

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/ValidateImage/stage`,
    data: data,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}
export async function uploadReconciliation(salesOrg: string, sapData: File): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  let data = new FormData();
  data.append('reconciliation', sapData);

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/sap/reconciliation`,
    data: data,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function uploadSalesCSV(salesOrg: string, salesData: File): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  let data = new FormData();
  data.append('sales', salesData);

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/salesdays/stage`,
    data: data,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}


export async function approveNoteCSV(salesOrg: string, keyId: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/notes/apply`,
    data: {keyId:keyId},
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function approveSalesCSV(salesOrg: string, keyId: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/salesdays/apply`,
    data: {keyId:keyId},
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function uploadSuspensionCSV(salesOrg: string, suspensionData: File): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  let data = new FormData();
  data.append('suspension', suspensionData);

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/suspension/stage`,
    data: data,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}


export async function approveSuspensionCSV(salesOrg: string, keyId: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/suspension/apply`,
    data: {keyId:keyId},
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export interface EquipmentCapacity {
  model: string;
  packType:string;
  packSize:string;
  columnSingleCapacity:string;
  nvcSingle:string;
  columnDoubleCapacity:string;
  nvcDouble:string;
  machinecategory:string;
  columnWidth:string;
}
export async function saveEquipmentCapacity(salesOrg: string, toDelete:EquipmentCapacity|undefined, toAdd:EquipmentCapacity|undefined): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/equipment/capacity`,
    data: {
      delete:(toDelete) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          model:toDelete.model,
          master :'Master',
          machinecategory:'BTL',
          packType:toDelete.packType,
          packSize:toDelete.packSize,
          columnSingleCapacity:parseInt(toDelete.columnSingleCapacity),
          nvcSingle:toDelete.nvcSingle,
          columnDoubleCapacity:parseInt(toDelete.columnDoubleCapacity),
          nvcDouble:toDelete.nvcDouble,
          columnWidth:toDelete.columnWidth,
        }]) : ([]),
      update:(toAdd) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          model:toAdd.model,
          master :'Master',
          machinecategory:'BTL',
          packType:toAdd.packType,
          packSize:toAdd.packSize,
          columnSingleCapacity:parseInt(toAdd.columnSingleCapacity),
          nvcSingle:toAdd.nvcSingle,
          columnDoubleCapacity:parseInt(toAdd.columnDoubleCapacity),
          nvcDouble:toAdd.nvcDouble,
          columnWidth:toAdd.columnWidth,
        }]) : ([]),
      },
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.log(err)
     );
}


interface MappingDL {
  model: string;
  master:string;
  maxFlavors:string;
  doubleColumns:string;
  itemsPerRow:string;
  columnConfig:string;
  minFlavors:string;
  guid:string;
  firstColumn:string;
  glassFront:string;
  machineModelType:string;
}


export async function saveEquipmentMapping(salesOrg: string, toDelete:MappingDL|undefined, toAdd:MappingDL|undefined): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/equipment/mapping`,
    data: {
      delete:(toDelete) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          model:toDelete.model,
          master:toDelete.master,
          maxFlavors:toDelete.maxFlavors,
          doubleColumns:toDelete.doubleColumns,
          itemsPerRow:toDelete.itemsPerRow,
          columnConfig:toDelete.columnConfig,
          minFlavors:toDelete.minFlavors,
          firstColumn:toDelete.firstColumn,
          glassFront:toDelete.glassFront,
          machineModelType:toDelete.machineModelType,
        }]) : ([]),
      update:(toAdd) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          model:toAdd.model,
          master:toAdd.master,
          maxFlavors:toAdd.maxFlavors,
          doubleColumns:toAdd.doubleColumns,
          itemsPerRow:toAdd.itemsPerRow,
          columnConfig:toAdd.columnConfig,
          minFlavors:toAdd.minFlavors,
          firstColumn:toAdd.firstColumn,
          glassFront:toAdd.glassFront,
          machineModelType:toAdd.machineModelType,
        }]) : ([]),
      },
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.log(err)
     );
}

interface MdMaterialStrategic {
   salesOffice:string;
   deliveringPlant:string;
  materialNum:string;
}
export async function saveMaterialStrategic(salesOrg: string, toDelete:MdMaterialStrategic|undefined, toAdd:MdMaterialStrategic|undefined): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/material/strategic`,
    data: {
      delete:(toDelete) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          salesOffice:toDelete.salesOffice,
          plant:toDelete.deliveringPlant,
          materialNum:toDelete.materialNum,
         
        }]) : ([]),
      update:(toAdd) ? ([{
          clientId:100,
          salesOrg:salesOrg,
          salesOffice:toAdd.salesOffice,
          plant:toAdd.deliveringPlant,
          materialNum:toAdd.materialNum,
        }]) : ([]),
      },
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.log(err)
     );
}

interface MdCensusSalesOrg {
  state:string;
 county:string;
}
export async function saveMap(salesOrg: string, toDelete:MdCensusSalesOrg |undefined, toAdd:MdCensusSalesOrg |undefined): Promise<any> {
 let params:{[key:string]:string} = {
   clientId: "100",
   salesOrg: salesOrg,
 }

 const config: AxiosRequestConfig = {
   method: "POST",
   params: params,
   url: `${BASE_URL}/api/admin/mapconfig`,
   data: {
     delete:(toDelete) ? ([{
         clientId:100,
         salesOrg:salesOrg,
         stateFips:toDelete.state,
         countyFips:toDelete.county,
        
       }]) : ([]),
     update:(toAdd) ? ([{
         clientId:100,
         salesOrg:salesOrg,
         stateFips:toAdd.state,
         countyFips:toAdd.county,
       }]) : ([]),
     },
 };

 return await AXIOS_INSTANCE(config)
   .then((v) => v)
   .catch((err) => console.log(err)
    );
}





interface MdMaterialReplacement {
 salesOffice:string;
 deliveringPlant:string;
 obsoleteMaterialNum:string;
 replacementMaterialNum:string;
 validFromDt: string;
 validToDt: string;

}
export async function saveMaterialReplacementDL(salesOrg: string, toDelete:MdMaterialReplacement|undefined, toAdd:MdMaterialReplacement|undefined): Promise<any> {

  let params:{[key:string]:string} = {
   clientId: "100",
   salesOrg: salesOrg
 }

 const config: AxiosRequestConfig = {
   method: "POST",
   params: params,
   url: `${BASE_URL}/api/admin/material/replace`,
   data: {
     delete:(toDelete) ? ([{
         clientId:100,
         salesOrg:salesOrg,
         salesOffice:toDelete.salesOffice,
         plant:toDelete.deliveringPlant, 
         obsoleteMaterialNum:toDelete.obsoleteMaterialNum,
         replacementMaterialNum:toDelete.replacementMaterialNum,
         validFromDt:toDelete.validFromDt,
         validToDt:toDelete.validToDt,
       }]) : ([]),
     update:(toAdd) ? ([{
      clientId:100,
      salesOrg:salesOrg,
      salesOffice:toAdd.salesOffice,
      plant:toAdd.deliveringPlant, 
      obsoleteMaterialNum:toAdd.obsoleteMaterialNum,
      replacementMaterialNum:toAdd.replacementMaterialNum,
      validFromDt:toAdd.validFromDt,
      validToDt:toAdd.validToDt,
       }]) : ([]),
     },
 };

 return await AXIOS_INSTANCE(config)
   .then((v) => v)
   .catch((err) => console.log(err)
    );
}


export async function uploadMaterialSortCSV(salesOrg: string, MaterialSort: File): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  let data = new FormData();
  data.append('sort', MaterialSort);

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/material/sort/stage`,
    data: data,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}



export async function approveMaterialSortCSV(salesOrg: string, keyId: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/csv/material/sort/apply`,
    data: {keyId:keyId},
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export interface CustEqupKey{
  customer_num:string;
  equipment_num:string;
}
export async function iSupValidateECA(clientId:string, salesOrg: string, deactivateAssignments:CustEqupKey[]): Promise<any> {
  let params:{[key:string]:string} = {
    clientId,
    salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/internalsupport/validate/mdEquipmentCustAssign`,
    data: {deactivateAssignments},
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function iSupDeactivateECA(clientId:string, salesOrg: string, deactivateAssignments:CustEqupKey[]): Promise<any> {
  let params:{[key:string]:string} = {
    clientId,
    salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/internalsupport/update/mdEquipmentCustAssign/DeactivateAssignment`,
    data: {deactivateAssignments},
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function iSupDeactivateAllSalesOfficeECA(clientId:string, salesOrg: string, salesOffice: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId,
    salesOrg,
    salesOffice,
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/internalsupport/deactivate/AllActiveSalesOfficeECA`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function searchSapLogs(salesOrg: string, searchId: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/admin/monitoring`,
    data: {searchId:searchId},
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function saveSyRouteConfiguration(salesOrg: string,client_id: number,param_name:string,param_value:boolean ): Promise<any> {
  
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg
     
    },
    data: {
      salesOrg,
      clientId: client_id,
      param_name:param_name,
      param_value: (param_value)?1:0,
    
     },
    url: `${BASE_URL}/api/admin/routeconfiguration`,
  };
  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}


export async function saveSysConfig(salesOrg: string, app:{vp?:boolean,vs?:boolean}, update:syConfig): Promise<any> {
  const data = {
    ...update,
    client_id: 100,
    sales_org: salesOrg,
    vs: (app.vs)?1:0,
    vp: (app.vp)?1:0
  }
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg
    },
    data,
    url: `${BASE_URL}/api/admin/setMaintenanceMode`,
  };
  return await AXIOS_INSTANCE(config)
  .then((v) => v.data)
  .catch((err) => console.error(err));
}

export async function DEX_Requeue(obj:string,salesOrg: string,type: string): Promise<any> {

  let data={
    client_id: 100,
    sales_org: salesOrg,
    obj,
    type
  }
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg
    },
    data,
    url: `${BASE_URL}/api/admin/dex/dex_Requeue`,
  };
  return await AXIOS_INSTANCE(config)
  .then((v) => v.data)
  .catch((err) => console.error(err));
}

export async function saveProtectCategory(salesOrg: string,client_id: number,category_id:string,active:boolean ): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg
    },
  data: {
    salesOrg,
    clientId: client_id,
    category_id:category_id,
    active: active,
  
   },
  url: `${BASE_URL}/api/admin/routeconfiguration`,
};
return await AXIOS_INSTANCE(config)
  .then((v) => v)
  .catch((err) => err.response);
}

interface TradeChannel {
  tradeChannel: string;
  subTradeChannel:string;
  fsv:number;
  convenience:number;
  guid?:string;
  
}
export async function saveTradeConfiguration(salesOrg: string, toDelete:TradeChannel|undefined, toAdd:TradeChannel|undefined): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    data: {
      delete:(toDelete) ? ([{
        client_id:100,
        sales_org:salesOrg,
        trade_channel:toDelete.tradeChannel,
        sub_trade_channel:toDelete.subTradeChannel,
        fsv_percentage:toDelete.fsv.toString(),
        convenience_percentage:toDelete.convenience.toString(),
        }]) : ([]),
      update:(toAdd) ? ([{
        client_id:100,
        sales_org:salesOrg,
        trade_channel:toAdd.tradeChannel,
        sub_trade_channel:toAdd.subTradeChannel,
        fsv_percentage:toAdd.fsv.toString(),
        convenience_percentage:toAdd.convenience.toString(),
        guid:toAdd.guid
        }]) : ([]),
      },
    url: `${BASE_URL}/api/admin/tradesubtradeconfig/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

interface BeverageCategoryThreshold {
  beverage_category: string;
  indiviual_material:string;
  config_type:string;
}

export async function saveThresholdConfig(salesOrg: string, toAdd:BeverageCategoryThreshold|undefined): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    data: {
      update:(toAdd) ? ([{
        client_id:100,
        sales_org:salesOrg,
        beverage_category:toAdd.beverage_category,
        indiviual_material:toAdd.indiviual_material,
        config_type:toAdd.config_type
        }]) : ([]),
      },
    url: `${BASE_URL}/api/admin/beveragecategory/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

interface BottleCanConfig {
  delivery_plant: string;
  type_override:string;
  machine_type:string;
  group_by:string;
  material_num:string;
  beverage_product:string;
  pack_type:string;
  pack_size:string;
  guid:string;
}

export async function saveBottleCanConfiguration(salesOrg: string, toDelete:BottleCanConfig|undefined, toAdd:BottleCanConfig|undefined): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    data: {
      delete:(toDelete) ? ([{
        client_id:100,
        sales_org:salesOrg,
        delivery_plant: toDelete.delivery_plant,
      type_override:toDelete.type_override,
      machine_type:toDelete.machine_type,
      group_by:toDelete.group_by,
      material_num:toDelete.material_num,
      beverage_product:toDelete.beverage_product,
      pack_type:toDelete.pack_type,
      pack_size:toDelete.pack_size,
        }]) : ([]),
      update:(toAdd) ? ([{
        client_id:100,
        sales_org:salesOrg,
        delivery_plant: toAdd.delivery_plant,
      type_override:toAdd.type_override,
      machine_type:toAdd.machine_type,
      group_by:toAdd.group_by,
      material_num:toAdd.material_num,
      beverage_product:toAdd.beverage_product,
      pack_type:toAdd.pack_type,
      pack_size:toAdd.pack_size,
      guid:toAdd.guid,
        }]) : ([]),
      },
    url: `${BASE_URL}/api/admin/bottlecanconfig/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function protectBeverageCategoryConfig(salesOrg: string,status:boolean,code:any): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    data: {
      salesOrg,
      status,
      code
      },
    url: `${BASE_URL}/api/admin/beveragecategory/protect`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function uploadImageToVsRepo(salesOrg: string, noteData: File,fileName?:string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  let data = new FormData();
let newFileName = fileName; 
let  renamedFile  = noteData;
if(newFileName) {
   renamedFile = new File([noteData], newFileName, { type: noteData.type });
}
data.append('VsImage', renamedFile);
if(fileName) {data.append('filname', fileName);}
const config: AxiosRequestConfig = {
  method: "POST",
  params: params,
  url: `${BASE_URL}/api/admin/uploadImageToVS`,
  data: data,
};

return await AXIOS_INSTANCE(config)
  .then((v) => v)
  .catch((err) => err.response);
}